import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { EMPTY, Observable } from 'rxjs'
import { JsspSettings } from './jssp-settings'
import { JsspSettingsService } from './jssp-settings.service'
import { catchError } from 'rxjs/operators'
import { ElderToastService } from '@elderbyte/ngx-starter'

@Injectable({
  providedIn: 'root',
})
export class JsspSettingsResolver {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private jsspSettingsService = inject(JsspSettingsService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<JsspSettings> {
    const id = route.paramMap.get('id')
    return this.jsspSettingsService.findById(id).pipe(
      catchError((err) => {
        this.toastService.error('messages.loading_failed', err)
        return EMPTY
      })
    )
  }
}
